import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  PublicBrand,
  PublicBrandCollectionFilter,
  PublicBrandDataSourceService,
} from '@web/shared/module/brand';
import { BreakpointService, SpinnerFilledComponent } from '@web/shared/ui';
import { PublicBrandTileComponent } from '../../components/public-brand-tile/public-brand-tile.component';
import { isNil, Nillable } from '@web/utils';
import {
  activatedRouteQueryParamAsString,
  Route,
  RouteParam,
  RouteQueryParam,
  RouterLinkComponent,
  RouterLinkParams,
} from '@web/common';
import { Observable, of, switchMap } from 'rxjs';

@Component({
  selector: 'app-public-brand-tiles',
  imports: [
    CommonModule,
    PublicBrandTileComponent,
    RouterLinkComponent,
    SpinnerFilledComponent,
  ],
  templateUrl: './public-brand-tiles.component.html',
  styleUrl: './public-brand-tiles.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicBrandTilesComponent {
  private readonly brandPublicDataSource = inject(PublicBrandDataSourceService);
  private readonly breakpoint = inject(BreakpointService);

  protected readonly currentCategoryName$ = this.currentCategoryNameSource();
  protected readonly tiles$ = this.tilesSource();
  protected readonly Route = Route;
  protected readonly RouteQueryParam = RouteQueryParam;
  protected readonly allCategoryName = 'all';
  protected readonly isMobile$ = this.isMobileSource();

  public routerLinkParams(slug: string): RouterLinkParams {
    return {
      [RouteParam.Slug]: slug,
    };
  }

  private isMobileSource(): Observable<boolean> {
    return this.breakpoint.observe('max-sm');
  }

  private tilesSource(): Observable<PublicBrand[]> {
    return this.currentCategoryName$.pipe(
      switchMap((name) => {
        if (name === this.allCategoryName) {
          return this.brandPublicDataSource.fetchBrands();
        }

        if (isNil(name)) {
          return of([]);
        }

        return this.brandPublicDataSource.fetchBrands(
          new PublicBrandCollectionFilter(name),
        );
      }),
    );
  }

  private currentCategoryNameSource(): Observable<Nillable<string>> {
    return activatedRouteQueryParamAsString(RouteQueryParam.PL_Category);
  }
}
